<template>
  <router-link
    class="item"
    :active-class="'active'"
    :to="{ name: 'user', params: { userId: user.original.id } }"
  >
    <div class="userListDisplay">
      <div class="profileIcon">
        <profile-icon :user="user.original" :size="'big'" />
      </div>
      <div class="userName content ellipsis">
        {{ user.original.name }}
      </div>
      <div class="extraData">
        <!-- Display yellow sheild if user is a super user -->
        <i :class="{ 'yellow shield icon': user.original.super }" />
        <!-- display qr code icon if user has 2fa enabled -->
        <i
          :class="{ 'qrcode icon': user.original.preferences && user.original.preferences['2fa'] }"
        />
      </div>
    </div>
  </router-link>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

.userListDisplay {
  display: flex;
  align-items: center;
}
.profileIcon {
  width: 20%;
}
.userName {
  width: 55%;
}
.extraData {
  width: 25%;
  text-align: right;
}
</style>

<script>
import ProfileIcon from './ProfileIcon.vue'
// @flow

export default {
  name: 'singleuser',
  components: { ProfileIcon },
  props: ['user']
}
</script>
